import React, { useState, useEffect } from "react";
import { Row } from "react-bootstrap";
import { addPermissionByColla, getAllColloborators } from "../services/roleApi";
import { useQuery } from "react-query";
import toast from "react-hot-toast";
import chevronRight from "../../../assets/images/chevron-right.png";
import { PERMISSIONS } from "../constants/Permissions";

const Collaborateur = () => {
  const [openSections, setOpenSections] = useState([0, 1, 2, 3]);
  const [checkedPermissions, setCheckedPermissions] = useState({});
  const [selectedCollab, setSelectedCollab] = useState(null);

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const currentMerchantId = currentUser?.user?.id;
  const merchantId = currentMerchantId;

  const { data: colloborateurs} = useQuery(
    ["colloborateurs", merchantId],
    () => getAllColloborators(merchantId),
    { enabled: !!merchantId }
  );

  // Définir les permissions de la section "Affichages"
  const isAffichagePermission = (permission) => {
    return [
      PERMISSIONS.VIEW_DASHBOARD,
      // PERMISSIONS.VIEW_PAYMENT_LINK,
      PERMISSIONS.MANAGE_COLLABORATORS,
    ].includes(permission);
  };

  // Définir les permissions de la section "Gestion des utilisateurs"
  const isGestionUserPermission = (permission) => {
    return [
      PERMISSIONS.CREATE_USER,
      PERMISSIONS.UPDATE_USER,
      PERMISSIONS.DELETE_USER,
    ].includes(permission);
  };

  // Charger les permissions du collaborateur sélectionné
  useEffect(() => {
    if (selectedCollab && colloborateurs) {
      const collab = colloborateurs.find(
        (c) => c.id === parseInt(selectedCollab)
      );
      if (collab) {
        const initialPermissions = {};
        collab.permissions.forEach((p) => {
          initialPermissions[p] = true;
        });
        // Ajouter automatiquement les permissions d'affichage comme cochées
        Object.values(PERMISSIONS).forEach((p) => {
          if (isAffichagePermission(p)) {
            initialPermissions[p] = true;
          }
        });
        setCheckedPermissions(initialPermissions);
      }
    } else {
      setCheckedPermissions({});
    }
  }, [selectedCollab, colloborateurs]);

  // 🔹 Changement d'état des permissions
  const handleCheck = async (permission) => {
    if (!selectedCollab) {
      alert("Veuillez sélectionner un collaborateur avant d’attribuer des droits");
      return;
    }

    setCheckedPermissions((prev) => {
      const newState = {
        ...prev,
        [permission]: !prev[permission],
      };

      const selectedPermissions = Object.keys(newState).filter((p) => newState[p]);

      const requestData = {
        collaboratorId: selectedCollab,
        permissions: selectedPermissions,
      }
      console.log("Current user > ", currentUser);
      addPermissionByColla(currentUser?.token, requestData)
        .then(() => toast.success("Permissions mises à jour !"))
        .catch(() => toast.error("Impossible de sauvegarder la permission"));

      return newState;
    });
  };

  // 🔹 Sections
  const sections = [
    {
      title: "Gestion des utilisateurs",
      users: [
        { label: "Créer un utilisateur", value: PERMISSIONS.CREATE_USER },
        { label: "Modifier un utilisateur", value: PERMISSIONS.UPDATE_USER },
        { label: "Supprimer un utilisateur", value: PERMISSIONS.DELETE_USER },
      ],
    },
    {
      title: "Gestion des opérations",
      users: [
        { label: "Faire un transfert", value: PERMISSIONS.TRANSFER },
        { label: "Créer un business", value: PERMISSIONS.CREATE_BUSINESS },
        { label: "Créer un lien de paiement ", value: PERMISSIONS.CREATE_PAYMENT_LINK },
        { label: "Faire une demande de reversement", value: PERMISSIONS.REQUEST_PAYOUT },
      ],
    },
    {
      title: "Gestion des transactions",
      users: [
        { label: "Voir les transactions", value: PERMISSIONS.VIEW_TRANSACTIONS },
        { label: "Voir les versements", value: PERMISSIONS.VIEW_PAYOUT },
        { label: "Voir les transferts", value: PERMISSIONS.VIEW_TRANSFER },
      ],
    },
    {
      title: "Affichages",
      users: [
        { label: "Consulter le dashboard", value: PERMISSIONS.VIEW_DASHBOARD },
        { label: "Consulter lien de paiement", value: PERMISSIONS.VIEW_PAYMENT_LINK },
        { label: "Consulter la gestion des rôles", value: PERMISSIONS.MANAGE_COLLABORATORS },
      ],
    },
  ];

  return (
    <Row>
      <div className="collab mb-2">Mes collaborateurs</div>

      {/* Sélecteur de collaborateur */}
      <div className="mb-4">
        <select
          value={selectedCollab || ""}
          onChange={(e) => setSelectedCollab(e.target.value)}
          className="form-select select"
        >
          <option value="">Sélectionner un collaborateur</option>
          {Array.isArray(colloborateurs) &&
            colloborateurs.map((collab) => (
              <option key={collab.id} value={collab.id}>
                {collab.fullName}
              </option>
            ))}
        </select>
      </div>

      {/* Sections */}
      <div className="mt-2 px-3">
        {sections.map((section, index) => (
          <div key={index} style={{ width: 757, marginBottom: "12px" }}>
            {/* Section Header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                backgroundColor: "#FFFFFF",
                border: "1px solid #E3E3E3",
                height: "40px",
                padding: "0 8px",
                gap: "8px",
                cursor: "pointer",
              }}
              onClick={() =>
                setOpenSections((prev) =>
                  prev.includes(index)
                    ? prev.filter((i) => i !== index)
                    : [...prev, index]
                )
              }
            >
              <span style={{ flex: 1, fontSize: 20, fontWeight: 500 }}>
                {section.title}
              </span>
              <img
                src={chevronRight}
                alt="chevron"
                style={{
                  width: 22,
                  transform: openSections.includes(index)
                    ? "rotate(90deg)"
                    : "rotate(0deg)",
                  transition: "0.2s ease",
                }}
              />
            </div>

            {/* Section Content */}
            {openSections.includes(index) && (
              <div
                style={{
                  padding: "8px",
                  border: "1px solid #E3E3E3",
                  backgroundColor: "#fff",
                }}
              >
                <span style={{ fontSize: 18 }}>Il peut :</span>

                {section.users.map((perm, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "6px 0",
                      gap: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={
                        isAffichagePermission(perm.value)
                          ? true
                          : checkedPermissions[perm.value] || false
                      }
                      disabled={
                        isAffichagePermission(perm.value) ||
                        isGestionUserPermission(perm.value)
                      }
                      onChange={() => {
                        if (
                          !isAffichagePermission(perm.value) &&
                          !isGestionUserPermission(perm.value)
                        ) {
                          handleCheck(perm.value);
                        }
                      }}
                    />

                    <li style={{ marginLeft: "20px" }}>{perm.label}</li>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </Row>
  );
};

export default Collaborateur;
